import { ref, watch, type DirectiveBinding, type VNode } from "vue";

export const toggleRadio = {
  mounted(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    const { value } = binding;
    const selectedOption = ref(value);
    console.log("取消选中", value);
    const handleRadioClick = (event: MouseEvent) => {
      const label = (event.target as HTMLInputElement).value;
      if (selectedOption.value === label) {
        selectedOption.value = null; // 取消选中
        if (typeof binding.value === "function") {
          binding.value(null);
        }
      } else {
        selectedOption.value = label;
        if (typeof binding.value === "function") {
          binding.value(label);
        }
      }
    };

    el.addEventListener("click", handleRadioClick);

    watch(
      () => value,
      newValue => {
        selectedOption.value = newValue;
      }
    );

    // 将事件监听器保存到 el 上，以便在 beforeUnmount 中移除
    (el as any).__toggleRadioClickHandler = handleRadioClick;
  },
  beforeUnmount(el: HTMLElement) {
    // 移除事件监听器
    const handleRadioClick = (el as any).__toggleRadioClickHandler;
    if (handleRadioClick) {
      el.removeEventListener("click", handleRadioClick);
      delete (el as any).__toggleRadioClickHandler;
    }
  }
};
